module.exports = __webpack_public_path__ + "img/enhancer.946ab491.webp";